import { useEffect, useState } from "react";
import { Text, View } from "react-native";
import { useTranslation } from "react-i18next";

import { Button } from "../primitives/Button";
import { Dialog } from "../primitives/Dialog";
import { TextField } from "../primitives/TextField";
import type { UiTheme } from "../theme";
import type { V3Styles } from "./v3Styles";

// #336 3b: the superset's name, written from the exercise menu.
/** «Rename superset»: an empty name goes back to «Superset N». */
export function SupersetRenameDialog({
  theme,
  styles,
  visible,
  current,
  onSave,
  onClose,
}: {
  theme: UiTheme;
  styles: V3Styles;
  visible: boolean;
  /** The stored name, or "" when the superset has none. */
  current: string;
  onSave: (name: string) => void;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [name, setName] = useState(current);
  useEffect(() => {
    if (visible) setName(current);
  }, [visible, current]);
  return (
    <Dialog
      theme={theme}
      visible={visible}
      onRequestClose={onClose}
      title={t("editorV3.renameSuperset", { defaultValue: "Rename superset" })}
    >
      <TextField
        theme={theme}
        value={name}
        onChangeText={setName}
        autoFocus
        accessibilityLabel={t("editorV3.supersetName", { defaultValue: "Superset name" })}
        maxLength={60}
      />
      <Text style={styles.muted}>
        {t("editorV3.supersetNameHint", { defaultValue: "Leave it empty to number it again." })}
      </Text>
      <View style={styles.dialogActions}>
        <Button theme={theme} variant="ghost" label={t("program.cancel", { defaultValue: "Cancel" })} onPress={onClose} />
        <Button
          theme={theme}
          label={t("program.save", { defaultValue: "Save" })}
          onPress={() => {
            onSave(name);
            onClose();
          }}
        />
      </View>
    </Dialog>
  );
}
